import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ClickOutsideModule } from 'ng-click-outside';
import { ToastrModule } from 'ngx-toastr';
import { NgxMyDatePickerModule } from 'ngx-mydatepicker';
import { NgxPaginationModule } from 'ngx-pagination';

import { ModalConfirmacionComponent } from '../components/modal-confirmacion/modal-confirmacion.component';

import { AccordionAnchorDirective, AccordionLinkDirective, AccordionDirective } from './accordion';
import { ToggleFullscreenDirective } from './fullscreen/toggle-fullscreen.directive';
import { AlphaNumericDirective } from '../nucleo/directiva/alpha-numeric.directive';
import { AccessOptionDirective } from '../nucleo/directiva/access-option.directive';
import { SortColumnDirective } from '../nucleo/directiva/sort-column.directive';
import { InterceptorService } from '../nucleo/interceptor/interceptor.service';
import { ServicioApiService } from '../servicio/servicio-api.service';
import { CardRefreshDirective } from './card/card-refresh.directive';
import { CardToggleDirective } from './card/card-toggle.directive';
import { SpinnerComponent } from '../spinner/spinner.component';
import { ServicioService } from '../servicio/servicio.service';
import { CardComponent } from './card/card.component';
import { MenuItems } from './menu-items/menu-items';
import { ModalImagenComponent } from '../components/modal-image/modal-imagen.component';


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        ClickOutsideModule,
        ToastrModule.forRoot(),
        NgxMyDatePickerModule.forRoot(),
        NgxPaginationModule
    ],
    declarations: [
        AccordionAnchorDirective,
        AccordionLinkDirective,
        AccordionDirective,
        ToggleFullscreenDirective,
        CardRefreshDirective,
        CardToggleDirective,
        CardComponent,
        SpinnerComponent,
        ModalConfirmacionComponent,
        ModalImagenComponent,
        SortColumnDirective,
        AlphaNumericDirective,
        AccessOptionDirective
    ],
    exports: [
        AccordionAnchorDirective,
        AccordionLinkDirective,
        AccordionDirective,
        ToggleFullscreenDirective,
        CardRefreshDirective,
        CardToggleDirective,
        CardComponent,
        SpinnerComponent,
        FormsModule,
        ReactiveFormsModule,
        ClickOutsideModule,
        ToastrModule,
        ModalConfirmacionComponent,
        ModalImagenComponent,
        SortColumnDirective,
        AlphaNumericDirective,
        AccessOptionDirective,
        NgxMyDatePickerModule,
        NgxPaginationModule
    ],
    providers: [
        MenuItems,
        ServicioApiService,
        ServicioService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: InterceptorService,
            multi: true
        }
    ]
})
export class SharedModule { }
